import { motion } from 'framer-motion';
import LocalizedLink from '@/components/LocalizedLink';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import heroMarketAccess from '@/assets/hero-market-access.jpg';

const MarketAccessCTA = () => {
  const { t } = useTranslation();

  return (
    <section className="relative h-[60vh] min-h-[500px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroMarketAccess}
          alt="Accès au marché français"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/80" />
      </div>

      {/* Content */}
      <div className="relative container-premium">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto"
        >
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
            {t('marketAccessCTA.title')}
          </h2>
          
          <p className="text-lg md:text-xl text-foreground/80 mb-10 leading-relaxed max-w-2xl mx-auto">
            {t('marketAccessCTA.subtitle')}
          </p>

          <div className="flex flex-wrap justify-center gap-4">
            <LocalizedLink to="/partenaires#formulaire-partenaire">
              <Button variant="gold" size="xl">
                {t('marketAccessCTA.ctaPrimary')}
                <ArrowRight size={20} />
              </Button>
            </LocalizedLink>
            <LocalizedLink to="/partenaires#pourquoi-nous">
              <Button variant="hero-outline" size="xl">
                {t('marketAccessCTA.ctaSecondary')}
              </Button>
            </LocalizedLink>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default MarketAccessCTA;
